import S from 's-js';
import { CachedModelLoader } from 'lib/CachedModelLoader';
import { DomainSummary } from 'data/models/DomainSummary';
import { UserSummary } from 'data/models/UserSummary';
import { MorePage as ServerMorePage, MorePageOptions } from 'data/models/MorePage';
import { MorePageCache } from './cache';

export function MorePage (
    loader : CachedModelLoader<ServerMorePage, MorePageOptions>,
    domain : DomainSummary,
    user : () => UserSummary | null,
    cache : MorePageCache
) {
    // TH 12/22/2016 -- Only attempt to load MorePage endpoint if we have a user...
    S(() => user() && loader({ UserId: user()!.Id() }, 30));
    // ... but supply a model from the cache whether we have a user or not.
    // This is to handle logouts from the MorePage.
    const model = S(() => cache.MorePages.update1(null, { UserId: user() ? user()!.Id() : 0 }));

    return {
        Model: model,
        Domain: domain,
        User: user
    };
}
export type MorePage = ReturnType<typeof MorePage>;


// WEBPACK FOOTER //
// ./apps/portcall/morepage/model.ts